import { writable } from 'svelte/store';
export const spriteframes = writable([]);
export const spritesheet_map = writable(new Map());
